import { Button, useMediaQuery } from "@material-ui/core";
import { useCallback, useEffect, useState } from "react";
import { BooleanField, BooleanInput, Datagrid, Filter, ImageField, Link, List, NumberField, required, SaveButton, SimpleForm, TextField, TextInput, Toolbar, TopToolbar, useCreate, useNotify, useRedirect } from "react-admin";
import { MyDateField } from "../MyDateField";
import { MyDateTimeInput } from "../MyDateTimeInput";
import { AssetBulkActionButtons } from "./components";
// popup
import { Add } from "@material-ui/icons";
import moment from "moment-timezone";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";

const ChannelFilter = ({ showAllOnChange, previewTimeOnChange, ...props }) => {
  return (
    <Filter {...props}>
      <TextInput label="OTT Ch Code" source="network_code" alwaysOn />
      <TextInput label="Ch No" source="channel_no" alwaysOn />
      <MyDateTimeInput label="Preview Date" source="preview_time" onChange={previewTimeOnChange} alwaysOn required={true} />
      <BooleanInput label="Show All Channels" source="show_all" defaultValue={false} alwaysOn onChange={showAllOnChange} />
    </Filter>
  );
};

const ListActions = (props) => {
  const ChannelCreatePopup = ({ close }) => {
    const CustomToolbar = (props) => {
      const redirectTo = useRedirect();
      const notify = useNotify();

      const [create] = useCreate("channel-no-list");

      const handleSave = useCallback(
        async (values) => {
          create(
            {
              payload: {
                data: {
                  channel_no: parseInt(values.channel_no),
                },
              },
            },
            {
              onSuccess: ({ data: newRecord }) => {
                redirectTo(`/channels?filter=${JSON.stringify({ channel_no: newRecord.channel_no })}`);
              },
              onFailure: (error) => {
                notify(error.message.toString(), "warning");
              },
            },
          );
        },
        [create, notify, redirectTo],
      );

      return (
        <Toolbar {...props}>
          <Button onClick={close}>Cancel</Button>
          <SaveButton onSave={handleSave} label="Create" />
        </Toolbar>
      );
    };

    return (
      <SimpleForm toolbar={<CustomToolbar />}>
        <TextInput label="Channel No" source="channel_no" validate={required()} fullWidth />
      </SimpleForm>
    );
  };

  return (
    <TopToolbar>
      <Popup
        trigger={
          <Button color="primary" startIcon={<Add />}>
            Create
          </Button>
        }
        modal
        closeOnDocumentClick={false}
      >
        {(close) => <ChannelCreatePopup close={close} {...props} />}
      </Popup>
      {/* <ExportButton /> */}
    </TopToolbar>
  );
};

export const ChannelNoList = (props) => {
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const MyEditButton = ({ record }) => {
    return <Link to={`/channels?filter=${JSON.stringify({ channel_no: record.channel_no })}`}> Edit</Link>;
  };

  const [previewDate, setPreviewDate] = useState(moment.tz("Asia/Hong_Kong")); //ALWAYS Store in UTC+8 timezone
  // const [datestring, setDatestring] = useState(moment.utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]", false));
  const [showAll, setShowAll] = useState(false);

  const previewTimeOnChange = (e) => {
    //Note: This is HK time, create moment object in HK time
    var x = moment.tz(e.target.value, "Asia/Hong_Kong");
    setPreviewDate(x);
    // setDatestring(moment(e.target.value).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]", false));
  };

  const showAllOnChange = (e) => {
    setShowAll(e);
  };

  const refreshData = () => {
    //NOTE: This doesn't work, because preview_time is set by filterDefaultValues
    setPreviewDate(moment.tz("Asia/Hong_Kong"));
  };

  // listen to refresh button on App Bar
  useEffect(() => {
    window.addEventListener("appBarRefreshButtonOnClick", function () {
      if (refreshData) {
        refreshData();
      }
    });
  }, []);

  return (
    <List
      {...props} //
      sort={{ field: "channel_no", order: "ASC" }}
      actions={<ListActions />}
      bulkActionButtons={<AssetBulkActionButtons />}
      filters={<ChannelFilter showAllOnChange={showAllOnChange} previewTimeOnChange={previewTimeOnChange} />}
      filterDefaultValues={{ preview_time: previewDate.format("YYYY-MM-DDTHH:mm"), show_all: showAll }}
    >
      {isSmall ? (
        <Datagrid rowClick="edit">
          <NumberField label="Ch No" source="channel_no" />
          <TextField label="Channel Name in TC" source="name_tc" />
          <BooleanField source="enabled" />
        </Datagrid>
      ) : (
        <Datagrid>
          <NumberField label="Ch No" source="channel_no" sortable={false} />
          <TextField label="OTT Ch Code" source="channel.network_code" sortable={false} />
          <TextField label="Channel Name in TC" source="channel.name_tc" sortable={false} />
          <TextField label="Channel Name in EN" source="channel.name_en" sortable={false} />
          <MyDateField label="Start Time" source="channel.start_time" sortable={false} showTime />
          <MyDateField label="End Time" source="channel.end_time" sortable={false} showTime />
          <ImageField label="Image (Landscape)" source="channel.landscape_poster" sortable={false} />
          <ImageField label="Image (Portrait)" source="channel.portrait_poster" sortable={false} />
          <MyEditButton />
        </Datagrid>
      )}
    </List>
  );
};
